module.exports = __webpack_public_path__ + "img/1 (6).39e9b307.jpg";